import { formatNumberWithK } from '~/helpers'
import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import {
  formatCompareMetricLabel,
  formatStylesChart,
  maxValue
} from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-impressions'

const settings = {
  label: i18n.t('rm:metrics.impressions'),
  formatData: (value: number) => formatNumberWithK({ number: value }),
  color: theme.colors.info,
  dataKey: 'impressionsNumber' as keyof ReportHistoryCampaigns,

  order: 100
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  selectedMetrics,
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  data,
  isCompare = false
}) => {
  const key = isCompare ? `${axisID}-compare` : axisID

  const shouldApplyMax = selectedMetrics?.includes('views')

  return {
    [key]: {
      display: showScaleRuler,
      position,
      grid: {
        // If true, draw lines on the chart area inside the axis lines. This is useful
        // when there are multiple axes and you need to control which grid lines are drawn.
        drawOnChartArea
      },
      beginAtZero: true,
      suggestedMin: 0,
      suggestedMax: shouldApplyMax ? maxValue({ data })?.metrics : null,
      ticks: {
        z: 30,
        color: settings.color,
        callback: settings.formatData
      }
    }
  }
}

const impressionsPreset = { axisID, dataset, optionsScale, settings }

export default impressionsPreset
